import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { closeModalAction } from "../../Redux/actions/modal";
import { useNavigate } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { PiEyeSlashLight, PiEyeThin } from "react-icons/pi";
import Logo from "../../Images/Logo.svg";
import { Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { RotatingLines } from "react-loader-spinner";

const Modal = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postalCode, setPostalCode] = useState("");
  // const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [subscribe, setSubscribe] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState("password");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeModalHandler = () => {
    dispatch(closeModalAction());
  };

  const navigateToLogin = () => {
    dispatch(closeModalAction());
    navigate("/login");
  };

  const handleSignup = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z]+$/;
    const phoneRegex = /^[0-9]+$/;
    let newErrors = {};

    if (!firstName) newErrors.firstName = "First Name is required";
    else if (!nameRegex.test(firstName))
      newErrors.firstName = "First Name must contain only letters";

    if (!lastName) newErrors.lastName = "Last Name is required";
    else if (!nameRegex.test(lastName))
      newErrors.lastName = "Last Name must contain only letters";

    if (!email) newErrors.email = "Email is required";
    else if (email && !emailRegex.test(email))
      newErrors.email = "Invalid email format";

    if (!phoneNumber) newErrors.phoneNumber = "Phone Number is required";
    else if (!phoneRegex.test(phoneNumber))
      newErrors.phoneNumber = "Phone Number must contain only numbers";

    if (!postalCode) newErrors.postalCode = "Postal Code is required";

   

    if (!password) newErrors.password = "Password is required";
    else if (password.length < 8)
      newErrors.password = "Password must be at least 8 characters";

    if (!confirmPassword)
      newErrors.confirmPassword = "Confirm Password is required";
    else if (password !== confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please complete the form before submitting.");
      return;
    }

    setLoading(true);
    const requestData = {
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber,
      postal_code: postalCode,
      subscribe: subscribe ? 1 : 0,
      email: email,
      password: password,
      password_confirmation: confirmPassword,
    };

    try {
      const response = await fetch(
        "https://backend.pmc-group.uk/api/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": "true",
            Accept: "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        toast.success(
          "Registration successful! Please check your email for verification."
        );
        navigateToLogin();
      } else {
        console.log("Failed to register user:", result);
        setErrors(result.errors || {});

        if (
          result.errors &&
          result.errors.email &&
          result.errors.email.includes("The email has already been taken.")
        ) {
          toast.error("The email address is already registered.");
        } else {
          toast.error(
            "Failed to register. Please check your details and try again."
          );
        }
      }
    } catch (error) {
      console.log("Error registering user:", error);
      setErrors({ general: "An unexpected error occurred. Please try again." });
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Disable background scrolling
    document.body.style.overflow = "hidden";

    // Re-enable scrolling when component is unmounted
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-screen h-screen opacity-100 bg-white z-30">
      <Toaster />
      <div className="flex md:justify-between justify-center md:ml-20 ">
        <Link to="/">
          <div className="xl:w-[300px] cursor-pointer">
            <img
              onClick={closeModalHandler}
              src={Logo}
              alt=""
              className="w-[150px]"
            />
          </div>
        </Link>
      </div>
      <div className="rounded-md py-8 shadow-xl overflow-y-scroll h-[85%]">
        <div className="flex items-center px-2">
          <div className="relative flex w-[90%] md:w-96 flex-col space-y-5 rounded-lg border bg-white px-3 py-10 shadow-xl mx-auto">
            <div className="-z-10 absolute top-4 left-1/2 h-full w-5/6 -translate-x-1/2 rounded-lg sm:-right-10 sm:top-auto sm:left-auto sm:w-full sm:translate-x-0"></div>

            <div
              onClick={closeModalHandler}
              className="absolute top-2 right-2 cursor-pointer"
            >
              <MdOutlineCancel className="md:text-2xl text-xl " />
            </div>
            <div className="mx-auto mb-2 space-y-3">
              <h1 className="text-center text-3xl font-bold text-gray-700">
                Sign up
              </h1>
              <p className="text-gray-500">Sign up with PMC</p>
            </div>

            <div>
              <div className="relative mt-2 w-full">
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.firstName ? "border-red-500" : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" "
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                  Enter First Name
                </label>
                {errors.firstName && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.firstName}
                  </p>
                )}
              </div>
            </div>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.lastName ? "border-red-500" : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" "
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                  Enter Surname
                </label>
                {errors.lastName && (
                  <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
                )}
              </div>
            </div>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.email ? "border-red-500" : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" "
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                  Enter Email Address
                </label>
                {errors.email && (
                  <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                )}
              </div>
            </div>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.phoneNumber ? "border-red-500" : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" "
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                  Enter Phone Number
                </label>
                {errors.phoneNumber && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.phoneNumber}
                  </p>
                )}
              </div>
            </div>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type="text"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.postalCode ? "border-red-500" : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" e.g., IV2 6FT/21"
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                 Postcode/House number
                </label>
                {errors.postalCode && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.postalCode}
                  </p>
                )}
              </div>
            </div>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type={showPassword}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.password ? "border-red-500" : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" "
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                  Enter Password (at least 8 characters)
                </label>
                <div
                  onClick={() =>
                    setShowPassword((prev) =>
                      prev === "password" ? "text" : "password"
                    )
                  }
                  className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer"
                >
                  {showPassword === "password" ? (
                    <PiEyeThin />
                  ) : (
                    <PiEyeSlashLight />
                  )}
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                )}
              </div>
            </div>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={`border-1 peer block w-full appearance-none rounded-lg border ${
                    errors.confirmPassword
                      ? "border-red-500"
                      : "border-gray-300"
                  } bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0`}
                  placeholder=" "
                />
                <label className="origin-[0] peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 absolute left-1 top-2 z-10 -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300">
                  Confirm Password
                </label>
                {errors.confirmPassword && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.confirmPassword}
                  </p>
                )}
              </div>
            </div>
            <div className="mt-4 flex items-center space-x-2">
              <input
                type="checkbox"
                checked={subscribe}
                onChange={(e) => setSubscribe(e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
              />
              <label className="text-sm text-gray-600">
                Subscribe to Newsletter
              </label>
            </div>
            {errors.general && (
              <p className="text-red-500 text-center text-xs">
                {errors.general}
              </p>
            )}
            <button
              onClick={handleSignup}
              className="mt-4 w-full button-content rounded-lg bg-blue-600 py-2 text-sm text-white hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? (
                <RotatingLines
                  strokeColor="#fff"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="20"
                  visible={true}
                />
              ) : (
                "Sign Up"
              )}
            </button>
            <p className="text-center text-sm text-gray-500 mt-2">
              Already have an account?{" "}
              <span
                onClick={navigateToLogin}
                className="text-blue-600 hover:underline cursor-pointer"
              >
                Log in
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
